import { ESTADO_REGULACAO_LABEL, type EstadoRegulacao } from "../types";

/**
 * Seletor do estado de regulação (eixo acalmar↔ativar) — antes ou depois do
 * momento. OPCIONAL: tocar o estado já marcado limpa (volta a "—"). 3 pontos
 * simétricos. Reaproveita as classes .status-opcoes do app.
 */
const ESTADOS: EstadoRegulacao[] = [
  "desregulado_baixo",
  "regulado",
  "desregulado_cima",
];

const ICONE: Record<EstadoRegulacao, string> = {
  desregulado_baixo: "↓",
  regulado: "≈",
  desregulado_cima: "↑",
};

export function RegulacaoSelector({
  valor,
  onChange,
  ariaLabel,
}: {
  valor: EstadoRegulacao | null;
  onChange: (v: EstadoRegulacao | null) => void;
  ariaLabel: string;
}) {
  return (
    <div className="status-opcoes" role="group" aria-label={ariaLabel}>
      {ESTADOS.map((e) => {
        const sel = valor === e;
        return (
          <button
            key={e}
            type="button"
            className={`status-opt${sel ? " sel" : ""}`}
            aria-pressed={sel}
            onClick={() => onChange(sel ? null : e)}
          >
            <span aria-hidden>{ICONE[e]}</span> {ESTADO_REGULACAO_LABEL[e]}
          </button>
        );
      })}
    </div>
  );
}
